export default {
  // backendBaseUrl: "https://uat.gold2u.app:3204",
  backendBaseUrl: "https://openapi.gold2u.app",
  defaults: {
    PAGE_SIZE: 20,
  },
};
